// exports createPromise, whenAll, resolve, reject
//         if$, not$, and$, or$, map$, forEach$, reduce$, filter$, find$, every$

import { map, invokeMap, last } from 'lodash';

/*
export const createPromise = function(executor) {
  return new Promise(executor);
};

export const resolve = function(x) { return Promise.resolve(x); };

export const reject = function(e) { return Promise.reject(e); };

export const whenAll = function(a) { return Promise.all(a); };
*/

let Cx = window['Cx'];

export const createPromise = Cx.createPromise;

export const resolve = Cx.resolve;

export const reject = Cx.reject;

export const whenAll = Cx.whenAll;


export const whenEach = function(things,action) {
  return whenAll( map(things,action) );
};

// Simple jQuery like Deferred pattern, useful for async queues
// Avoid its use as possible, using createPromise directly
export const Deferred = function() {
  this.promise = createPromise( (resolve,reject) => {
    this.resolve = resolve;
    this.reject  = reject;
  });
};

// Creates a promise that only excecutes when .run(...)
// is called. This is useful to avoid the use of the deferred pattern
// when implementing async queues. If the lazy promise is deleted,
// the execution will just be canceled
// This is a simple implementation, that forces users of the
// lazy promise to know it is not a regular promise. Other implementation
// hide the start of the execution in the .then function
// https://github.com/nailgun/q-lazy/blob/master/index.js
export const createLazyPromise = function(executor) {
  let p;
  return {
    promise: createPromise( (resolve,reject) => p = {resolve,reject} ),
    run() {
      executor(p.resolve,p.reject);
    }
  };
};

export const if$ = function(condition,body) {
  let p = ( condition ? body() : null );
  if( ! ( p && p.then ) ) {
    p = resolve();
  }
  if( condition ) {
    p.else_if$ = p.else$ = discarded_else$;
  }
  else {
    p.else_if$ = else_if$;
    p.else$    = else$;
  }
  return p;
};

function else$(body) {
  return if$(true,body);
}
function else_if$(condition,body) {
  return if$(condition,body);
}
function discarded_else$() {
  // Forward the if promise
  return this;
}

export const wait$ = function(ms) {
  return createPromise( resolve => setTimeout(() => resolve(), ms ) );
};

export const map$ = function( a, f ) {
  return whenAll( map(a,f) );
};

export const invokeMap$ = function( ...params ) {
  return whenAll( invokeMap(...params) );
};

export const not$ = function(p) {
  return p .then( r => ! r );
};
export const and$ = function(p0,p1) {
  return whenAll([ p0, p1 ]) .then( r => r[0] && r[1] );
};
export const or$ = function(p0,p1) {
  return whenAll([ p0, p1 ]) .then( r => r[0] || r[1] );
};

// forEach$ executes promises in order, use whenEach$ if you do not care
// about order of execution, it will be faster that way
export const forEach$ = function(array,action,context,i) {
  const c = array.length;
  if( c > 0 ) {
    return action.call(context,array[0],i||0) .then( v0 => {
      const va = [v0];
      return c === 1 ? va
                     : va.concat( forEach$(array.slice(1),action,context,++i) );
    });
  }
  else {
    return resolve([]);
  }
};

// [TODO] tail optimization

export const reduce$ = function( ts, f, r ) {
  if( ts.length === 0 ) {
    return resolve(r);
  }
  const t = ts[0];
  const rest = ts.slice(1);
  return f(t,r) .then( nr => {
  return reduce$(rest,f,nr);
  });
};

export const filter$ = function( array, check ) {
  return map$(array,check) .then( result => {
  const filtered = [];
  for( let k = 0, kEnd = result.length; k<kEnd ; ++k ) {
    if( result[k] ) {
      filtered.push(array[k]);
    }
  }
  return filtered;
  });
};

export const find$ = function( array, check ) {
  if( array.length === 0 ) {
    return resolve();
  }
  const first = array[0];
  return check(first) .then( pass => {
  if( pass ) {
    return resolve(first);
  }
  else {
    return find$( array.slice(1), check );
  }
  });
};

export const findLast$ = function( array, check ) {
  if( array.length === 0 ) {
    return resolve();
  }
  const l = last(array);
  return check(l) .then( pass => {
  if( pass ) {
    return resolve(l);
  }
  else {
    return findLast$( array.slice(0,array.length-1), check );
  }
  });
};

export const every$ = function( ts, f ) {
  return map$(ts,f) .then( result => {
  for( let k = 0, kEnd = result.length; k<kEnd ; ++k ) {
    if( ! result[k] ) {
      return false;
    }
  }
  return true;
  });
};



/** WEBPACK FOOTER **
 ** ./src/gear/promise.js
 **/